
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { from, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorOccurredProps } from '@ffq-app-shared/model/segment.data.model';
import { SegmentService } from '@ffq-app-shared/services/segment.service';
import { SmartyAddress } from '@ffq-app-shared/model/common.data.model';



@Injectable({
  providedIn: 'root'
})
export class SmartyAddressService {
  private apiUrl = environment.SMARTY_API_URL;
  private key = environment.SMARTY_EMBEDDED_KEY;
  private isSmartyEnabled = environment.enable_smarty_autoComplete;


  constructor(private http: HttpClient, private segmentService: SegmentService,) { }

  public getAddressSuggestions(suggestion: string, zipCode: string, state: string): Observable<SmartyAddress[]> {
    if (this.isSmartyEnabled !== 'Y') {
      return of([]);
    }

    let params = new HttpParams().set('search', suggestion);
    if (zipCode) {
      params = params.set('include_only_zip_codes', zipCode);
    } else if (state) {
      params = params.set('include_only_states', state);
    }
    params = params.set('source', 'all');
    params = params.set('key', this.key);
    return this.http.get(this.apiUrl, { params }).pipe(
      map((response: any) => this.processResponse(response)),
      catchError((error: any) => this.handleError(error))
    );
  }

  private processResponse(response: any): SmartyAddress[] {
  const filteredOptions: SmartyAddress[] = [];
  // console.log(response);
  const suggestions = response?.suggestions;
  if (response && Array.isArray(suggestions) && suggestions.length > 0) {
      suggestions.forEach((item: any) => {
        if (item.entries === 0 || suggestions.length === 1) {
          let address = {} as any;
          address.full_address = this.removeAccents(item.street_line) + ', ' + this.removeAccents(item.city) + ' ' + this.removeAccents(item.state) + ' ' + this.removeAccents(item.zipcode);
          address.new_address = this.removeAccents(item.street_line);
          address.city = this.removeAccents(item.city);
          address.zip = this.removeAccents(item.zipcode);
          address.state = this.removeAccents(item.state);
          address.country = 'USA';
          filteredOptions.push(address);
        }
      });
      if (filteredOptions.length > 5) {
        return filteredOptions.slice(0, 5);
      }
    }

    return filteredOptions;
  }

  private handleError(errorFromSmarty: any): Observable<SmartyAddress[]> {
    let errorMessages;
    if (errorFromSmarty && errorFromSmarty.payload && Array.isArray(errorFromSmarty.payload.errors)) {
      errorMessages = errorFromSmarty.payload.errors[0].message;
    } else {
      errorMessages = ['Smarty Address Auto Complete API failed'];
    }
    const errorOccurredProps: Partial<ErrorOccurredProps> = {
      error_type: 'API Request Error',
      error_location: 'Smarty Address Auto Complete',
      error_description: errorMessages,
    };
    this.segmentService.trackErrorOccurred(errorOccurredProps);

    return of([]);
  }

  removeAccents(address_str: string): string {
    return (
      address_str &&
      address_str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    );
  }
}